import { useState } from "react";
import { Card } from "@/components/Card";
import { Btn } from "@/components/Btn";
import { SectionHeader } from "@/components/SectionHeader";
import { SettingsRow, S_INPUT } from "@/components/SettingsRow";
import { Toggle } from "@/components/Toggle";

export function DatenSection() {
  const [autoBackup, setAutoBackup] = useState(true);

  return (
    <>
      <Card style={{ marginBottom: 16 }}>
        <SectionHeader
          title="Export & Backup"
          desc="Daten herunterladen oder regelmäßige Sicherung einrichten. (Vorschau — Funktionen folgen.)"
        />
        <SettingsRow
          label="Buchungen als Excel"
          hint="Alle Buchungen des aktuellen Jahres als .xlsx"
        >
          <Btn variant="secondary" icon="file_download" size="sm" disabled>
            Herunterladen
          </Btn>
        </SettingsRow>
        <SettingsRow
          label="Vollständiges Backup"
          hint="Alle Daten, E-Mails und Dokumente als .zip"
        >
          <Btn variant="secondary" icon="cloud_download" size="sm" disabled>
            Backup erstellen
          </Btn>
        </SettingsRow>
        <SettingsRow
          label="Automatisches Backup"
          hint="Täglich um 03:00 Uhr auf den konfigurierten Speicher"
        >
          <Toggle on={autoBackup} onChange={setAutoBackup} />
        </SettingsRow>
        <SettingsRow label="Backup-Ziel">
          <select style={{ ...S_INPUT, maxWidth: 240 }} disabled>
            <option>Lokaler Server</option>
            <option>S3-kompatibler Speicher</option>
            <option>WebDAV (Nextcloud)</option>
          </select>
        </SettingsRow>
      </Card>

      <Card>
        <SectionHeader
          title="Aufbewahrung & DSGVO"
          desc="Wie lange werden abgeschlossene Buchungen und personenbezogene Daten aufbewahrt? (Vorschau — Funktionen folgen.)"
        />
        <SettingsRow label="Abgeschlossene Buchungen">
          <select style={{ ...S_INPUT, maxWidth: 200 }} disabled defaultValue="10 Jahre">
            <option>3 Jahre</option>
            <option>10 Jahre</option>
            <option>Unbegrenzt</option>
          </select>
        </SettingsRow>
        <SettingsRow label="Stornierte Buchungen">
          <select style={{ ...S_INPUT, maxWidth: 200 }} disabled>
            <option>1 Jahr</option>
            <option>3 Jahre</option>
          </select>
        </SettingsRow>
        <SettingsRow label="Daten einer Person löschen" hint="DSGVO-Auskunft & Löschanfragen">
          <Btn variant="danger" icon="delete" size="sm" disabled>
            Löschassistent öffnen
          </Btn>
        </SettingsRow>
      </Card>
    </>
  );
}
